import React, { useEffect, useMemo, useRef, useState } from "react";

import { CircleF, GoogleMap, PolylineF, PolygonF } from "@react-google-maps/api";
import { useGoogleMaps } from "../../../providers/GoogleMapsProvider";

import * as ReactDOM from 'react-dom/client';
import { Card, CloseButton, Col, Row, Spinner } from "react-bootstrap";
import { mapStore } from "../../../lib/store/map_store";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

import IconoAlerta from '../../../assets/img/alertas/alerta.png';
import IconoFecha from '../../../assets/img/alertas/fecha.png';
import IconoHora from '../../../assets/img/alertas/hora.png';
import IconoRuta from '../../../assets/img/alertas/ruta.png';
import IconoVelocidad from '../../../assets/img/alertas/velocidad.png';
import IconoUsuario from '../../../assets/img/alertas/usuario.png';
import Flex from "../Flex";
import { obtenerIconoEvento } from "./IconosTabla";

export const iAlerta = <img src={IconoAlerta} alt="Logo" style={{ height: '30px', width: '30px' }} />;
export const iFecha = <img src={IconoFecha} alt="Logo" style={{ height: '30px', width: '30px' }} />;
export const iHhora = <img src={IconoHora} alt="Logo" style={{ height: '30px', width: '30px' }} />;
export const iRuta = <img src={IconoRuta} alt="Logo" style={{ height: '30px', width: '30px' }} />;
export const iVelocidad = <img src={IconoVelocidad} alt="Logo" style={{ height: '30px', width: '30px' }} />;
export const iUsuario = <img src={IconoUsuario} alt="Logo" style={{ height: '30px', width: '30px' }} />;

export const iconAlertaDetenido =
{
    url: `
            data:image/svg+xml;charset=UTF-8,
            ${encodeURIComponent(`<svg width="40" height="40" viewBox="0 0 100 125" xmlns="http://www.w3.org/2000/svg" fill="none">
                <path d="M50 125C50 125 90 80 90 50C90 22.3858 69.6142 2 50 2C30.3858 2 10 22.3858 10 50C10 80 50 125 50 125Z" fill="red"/>
                <circle cx="50" cy="55" r="55" fill="red"/>
                <circle cx="50" cy="55" r="40" fill="white"/>
                <g transform="translate(12, 20) scale(2.8)">
                    <path d="M14 3.5V11V4.5C14 3.67157 14.6716 3 15.5 3C16.3284 3 17 3.67157 17 4.5V11V7.5C17 6.67157 17.6716 6 18.5 6C19.3284 6 20 6.67157 20 7.5V16C20 19.3137 17.3137 22 14 22H12.8727C11.3483 22 9.88112 21.4198 8.76904 20.3772L3.81045 15.7285C3.09365 15.0565 3.0754 13.9246 3.77016 13.2298C4.44939 12.5506 5.55063 12.5506 6.22985 13.2298L8.00001 15V6.5C8.00001 5.67157 8.67158 5 9.50001 5C10.3284 5 11 5.67157 11 6.5V11V3.5C11 2.67157 11.6716 2 12.5 2C13.3284 2 14 2.67157 14 3.5Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
            </svg>`)}
         `,
};
export const iconDetenido =
{
    url: `
        data:image/svg+xml;charset=UTF-8,
        ${encodeURIComponent(`<svg width="40" height="40" viewBox="0 0 100 125" xmlns="http://www.w3.org/2000/svg" fill="none">
            <path d="M50 125C50 125 90 80 90 50C90 22.3858 69.6142 2 50 2C30.3858 2 10 22.3858 10 50C10 80 50 125 50 125Z" fill="#EED202"/>
            <circle cx="50" cy="55" r="55" fill="#EED202"/>
            <circle cx="50" cy="55" r="40" fill="white"/>
            <g transform="translate(12, 20) scale(2.8)">
                <path d="M14 3.5V11V4.5C14 3.67157 14.6716 3 15.5 3C16.3284 3 17 3.67157 17 4.5V11V7.5C17 6.67157 17.6716 6 18.5 6C19.3284 6 20 6.67157 20 7.5V16C20 19.3137 17.3137 22 14 22H12.8727C11.3483 22 9.88112 21.4198 8.76904 20.3772L3.81045 15.7285C3.09365 15.0565 3.0754 13.9246 3.77016 13.2298C4.44939 12.5506 5.55063 12.5506 6.22985 13.2298L8.00001 15V6.5C8.00001 5.67157 8.67158 5 9.50001 5C10.3284 5 11 5.67157 11 6.5V11V3.5C11 2.67157 11.6716 2 12.5 2C13.3284 2 14 2.67157 14 3.5Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
        </svg>`)}
    `,
};
export const iconAlerta =
{
    url: `
            data:image/svg+xml;charset=UTF-8,
            ${encodeURIComponent(`<svg width="40" height="40" viewBox="0 0 100 125" xmlns="http://www.w3.org/2000/svg" fill="none">
            <path d="M50 125C50 125 90 80 90 50C90 22.3858 69.6142 2 50 2C30.3858 2 10 22.3858 10 50C10 80 50 125 50 125Z" fill="lightgray"/>
            <circle cx="50" cy="55" r="55" fill="lightgray"/>
            <circle cx="50" cy="55" r="40" fill="white"/>
            <text x="50%" y="50%" font-family="Times New Roman, sans-serif" font-size="70" font-weight="bold" fill="black" text-anchor="middle" dominant-baseline="middle">!</text>
            </svg>`)}
         `
};
export const iconMotorEncendido =
{
    url: `
        data:image/svg+xml;charset=UTF-8,
        ${encodeURIComponent(`<svg width="80" height="40" viewBox="55 0 100 110" xmlns="http://www.w3.org/2000/svg" fill="none">
            <path transform="rotate(-50 50 50)" d="M50 125C50 125 90 80 90 50C90 22.3858 69.6142 2 50 2C30.3858 2 10 22.3858 10 50C10 80 50 125 50 125Z" fill="green"/>
            <circle cx="50" cy="55" r="55" fill="green"/>
            <circle cx="50" cy="55" r="40" fill="white"/>
            <g transform="translate(19, 30) scale(0.5)">
                <path fill="black" d="M43.58,92.2L31.9,80.53h-8.04c-2.81,0-5.11-2.3-5.11-5.11v-8.7h-4.87V76.9c0,2.17-1.78,3.95-3.95,3.95H3.95 C1.78,80.85,0,79.07,0,76.9V42.4c0-2.17,1.78-3.95,3.95-3.95h5.98c2.17,0,3.95,1.78,3.95,3.95v10.18h4.87v-9.36 c0-2.81,2.3-5.11,5.11-5.11h8.54l12.07-12.83c1.4-1.22,3.26-1.65,5.43-1.56h49.73c1.72,0.19,3.03,0.85,3.83,2.09 c0.8,1.22,0.67,1.91,0.67,3.28v23.49H109V42.4c0-2.17,1.78-3.95,3.95-3.95h5.98c2.17,0,3.95,1.78,3.95,3.95v34.5 c0,2.17-1.78,3.95-3.95,3.95h-5.98c-2.17,0-3.95-1.78-3.95-3.95V66.72h-4.87v0.92c0,2.73,0.08,4.38-1.66,6.64 c-0.33,0.43-0.7,0.84-1.11,1.22L83.53,92.96c-0.89,0.99-2.24,1.53-4.02,1.63h-30.4C46.84,94.49,44.99,93.71,43.58,92.2L43.58,92.2z M63.71,61.78l-12.64-1.19l10.48-22.96h14.33l-8.13,13.17l14.62,1.62L55.53,84.64L63.71,61.78L63.71,61.78z M51.98,0h34.5 c2.17,0,3.95,1.78,3.95,3.95v5.98c0,2.17-1.78,3.95-3.95,3.95H76.3v5.03H62.16v-5.03H51.98c-2.17,0-3.95-1.78-3.95-3.95V3.95 C48.03,1.78,49.81,0,51.98,0L51.98,0z"/>
            </g>
        </svg>`)}
    `,
};
export const iconMotorApagado =
{
    url: `
        data:image/svg+xml;charset=UTF-8,
        ${encodeURIComponent(`<svg width="80" height="40" viewBox="-55 0 100 110" xmlns="http://www.w3.org/2000/svg" fill="none">
            <path transform="rotate(50 50 50)" d="M50 125C50 125 90 80 90 50C90 22.3858 69.6142 2 50 2C30.3858 2 10 22.3858 10 50C10 80 50 125 50 125Z" fill="red"/>
            <circle cx="50" cy="55" r="55" fill="red"/>
            <circle cx="50" cy="55" r="40" fill="white"/>
            <g transform="translate(19, 30) scale(0.5)">
                <path fill="black" d="M43.58,92.2L31.9,80.53h-8.04c-2.81,0-5.11-2.3-5.11-5.11v-8.7h-4.87V76.9c0,2.17-1.78,3.95-3.95,3.95H3.95 C1.78,80.85,0,79.07,0,76.9V42.4c0-2.17,1.78-3.95,3.95-3.95h5.98c2.17,0,3.95,1.78,3.95,3.95v10.18h4.87v-9.36 c0-2.81,2.3-5.11,5.11-5.11h8.54l12.07-12.83c1.4-1.22,3.26-1.65,5.43-1.56h49.73c1.72,0.19,3.03,0.85,3.83,2.09 c0.8,1.22,0.67,1.91,0.67,3.28v23.49H109V42.4c0-2.17,1.78-3.95,3.95-3.95h5.98c2.17,0,3.95,1.78,3.95,3.95v34.5 c0,2.17-1.78,3.95-3.95,3.95h-5.98c-2.17,0-3.95-1.78-3.95-3.95V66.72h-4.87v0.92c0,2.73,0.08,4.38-1.66,6.64 c-0.33,0.43-0.7,0.84-1.11,1.22L83.53,92.96c-0.89,0.99-2.24,1.53-4.02,1.63h-30.4C46.84,94.49,44.99,93.71,43.58,92.2L43.58,92.2z M63.71,61.78l-12.64-1.19l10.48-22.96h14.33l-8.13,13.17l14.62,1.62L55.53,84.64L63.71,61.78L63.71,61.78z M51.98,0h34.5 c2.17,0,3.95,1.78,3.95,3.95v5.98c0,2.17-1.78,3.95-3.95,3.95H76.3v5.03H62.16v-5.03H51.98c-2.17,0-3.95-1.78-3.95-3.95V3.95 C48.03,1.78,49.81,0,51.98,0L51.98,0z"/>
            </g>
        </svg>
`)}
    `,
};
export const iconPunto =
{
    url: `
            data:image/svg+xml;charset=UTF-8,
            ${encodeURIComponent(`<svg width="40" height="40" viewBox="0 0 100 125" xmlns="http://www.w3.org/2000/svg" fill="none">
            <path d="M50 125C50 125 90 80 90 50C90 22.3858 69.6142 2 50 2C30.3858 2 10 22.3858 10 50C10 80 50 125 50 125Z" fill="#f44546"/>
            <circle cx="50" cy="55" r="55" fill="#f44546"/>
            <circle cx="50" cy="55" r="40" fill="white"/>
            <text x="50%" y="50%" font-family="Times New Roman, sans-serif" font-size="70" font-weight="bold" fill="black" text-anchor="middle" dominant-baseline="middle">P</text>
            </svg>`)}
         `,
};
export const iconPuntoNoEconomico =
{
    url: `
            data:image/svg+xml;charset=UTF-8,
            ${encodeURIComponent(`<svg width="40" height="40" viewBox="0 0 100 125" xmlns="http://www.w3.org/2000/svg" fill="none">
            <path d="M50 125C50 125 90 80 90 50C90 22.3858 69.6142 2 50 2C30.3858 2 10 22.3858 10 50C10 80 50 125 50 125Z" fill="#f44546"/>
            <circle cx="50" cy="55" r="55" fill="#f44546"/>
            <circle cx="50" cy="55" r="40" fill="white"/>
            <text x="50%" y="50%" font-family="Times New Roman, sans-serif" font-size="40" font-weight="bold" fill="black" text-anchor="middle" dominant-baseline="middle">noEco</text>
            </svg>`)}
         `,
};
export const iconPuntoI =
{
    url: `
            data:image/svg+xml;charset=UTF-8,
            ${encodeURIComponent(`<svg width="40" height="40" viewBox="0 0 100 125" xmlns="http://www.w3.org/2000/svg" fill="none">
            <path d="M50 125C50 125 90 80 90 50C90 22.3858 69.6142 2 50 2C30.3858 2 10 22.3858 10 50C10 80 50 125 50 125Z" fill="#f44546"/>
            <circle cx="50" cy="55" r="55" fill="#f44546"/>
            <circle cx="50" cy="55" r="40" fill="white"/>
            <text x="50%" y="50%" font-family="Times New Roman, sans-serif" font-size="70" font-weight="bold" fill="black" text-anchor="middle" dominant-baseline="middle">I</text>
            </svg>`)}
         `,
};
export const iconPuntoF =
{
    url: `
            data:image/svg+xml;charset=UTF-8,
            ${encodeURIComponent(`<svg width="40" height="40" viewBox="0 0 100 125" xmlns="http://www.w3.org/2000/svg" fill="none">
            <path d="M50 125C50 125 90 80 90 50C90 22.3858 69.6142 2 50 2C30.3858 2 10 22.3858 10 50C10 80 50 125 50 125Z" fill="#f44546"/>
            <circle cx="50" cy="55" r="55" fill="#f44546"/>
            <circle cx="50" cy="55" r="40" fill="white"/>
            <text x="50%" y="50%" font-family="Times New Roman, sans-serif" font-size="70" font-weight="bold" fill="black" text-anchor="middle" dominant-baseline="middle">F</text>
            </svg>`)}
         `,
};
export const iconPin = {
    url: `
                    data:image/svg+xml;charset=UTF-8,
                    ${encodeURIComponent(`<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="60" viewBox="0 0 32 32" xml:space="preserve">
                    <g>
                        <path fill="#f44546" d="M20.995,15.479c0.024-0.712-0.452-1.438-1.488-1.978v-1.321c1.201-0.619,1.548-1.395,1.488-2.054
                            V8.606c-0.004-0.668-0.442-1.337-1.315-1.839c-1.767-1.018-4.623-1.023-6.379-0.012c-1.426,0.821-1.295,1.835-1.295,1.835v1.535
                            c-0.045,0.645,0.3,1.414,1.488,2.033c0,0,0,1.431,0,1.321c-1.038,0.535-1.513,1.259-1.488,1.971v1.489
                            c-0.049,0.702,0.381,1.414,1.315,1.952c1.767,1.018,4.623,1.023,6.379,0.012c0.935-0.539,1.36-1.256,1.295-1.964V15.479z"/>
                        <path fill="#BE1E2D" d="M20.995,15.421v1.519c0.065,0.707-0.36,1.425-1.295,1.964c-1.756,1.011-4.612,1.006-6.379-0.012
                            c-0.934-0.538-1.364-1.25-1.315-1.952v-1.535c0.004,0.665,0.432,1.331,1.315,1.839c1.767,1.018,4.623,1.023,6.379,0.012
                            C20.578,16.75,20.998,16.086,20.995,15.421z M20.995,8.606c0.013,2.387-5.004,3.362-7.675,1.823
                            c-0.883-0.509-1.311-1.175-1.315-1.839v1.535l0,0c-0.045,0.645,0.3,1.414,1.488,2.033v1.782h0.006
                            c-0.015,0.456,0.275,0.916,0.881,1.265c1.178,0.679,3.082,0.682,4.253,0.008c0.607-0.35,0.891-0.813,0.866-1.273h0.009v-1.761
                            c1.201-0.619,1.548-1.395,1.488-2.054l0,0V8.606z"/>
                        <path fill="#72C0AB" d="M15.5,19.583v5.537h0.002c0,0,0.997,1.878,0.998,1.88c0.001-0.001,0.999-1.88,1-1.88v-2.828
                            c-0.389-1.005-0.881-1.905-1.463-2.661C15.857,19.62,15.678,19.607,15.5,19.583z"/>
                        <path fill="#569080" d="M16.037,19.631c0.582,0.755,1.074,1.656,1.463,2.661v-2.701
                            C17.019,19.652,16.527,19.662,16.037,19.631z"/>
                    </g>
                    </svg>`)}
                 `,
};
const defaultTransform = 'translate(-50%, -140%)';
export const obtenerInfoView = (data) => {
    let dataStyle = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
    return ({
        headerColor: `${data.colorFondoTitulo}`,
        customTransform: data.ocultarBody ? 'translate(-50%, -230%)' : defaultTransform,
        header:
            <>
                <Col key={`marker_${data.markerId}`} className={`text-center p-0 m-0 ${data.colorTextoTitulo}`}>
                    {data.titulo}
                </Col>
            </>,
        body: data.ocultarBody ? null : <div key={`marker_${data.markerId}`}>
            <Row className='m-0 p-0 flex-nowrap'>
                {data.velocidad === '' ? <></> : <div style={{ width: 100 }} className="m-1 text-center">
                    {iVelocidad}
                    <Row md={12}><span className="fw-bold m-0 p-0" style={dataStyle} title={data.velocidad}> {data.velocidad} KM/H</span></Row>
                </div>}
                <div style={{ width: data.velocidad === '' ? 215 : 100 }} className="m-1 text-center">
                    {iAlerta}
                    <Row md={12}><span className="fw-bold m-0 p-0" style={dataStyle} title={data.alerta}> {data.alerta} </span></Row>
                </div>
                <div style={{ width: 100 }} className="m-1 text-center">
                    {iFecha}
                    <Row md={12}><span className="fw-bold m-0 p-0" style={dataStyle} title={data.fecha}>{data.fecha}</span></Row>
                </div>
                <div style={{ width: 100 }} className="m-1 text-center">
                    {iHhora}
                    <Row md={12}><span className="fw-bold m-0 p-0" style={dataStyle} title={data.hora}>{data.hora}</span></Row>
                </div>
            </Row>
            <Row className='m-0 p-0 flex-nowrap'>
                <div style={{ width: 100 }} className="m-1 text-left">
                    {iRuta}
                    <span className="fw-bold m-0 p-0" style={dataStyle} title={data.ruta}> {data.ruta} </span>
                </div>
                <div style={{ width: 315 }} className="m-1 text-left">
                    {iUsuario}
                    <span className="fw-bold m-0 p-0" style={dataStyle} title={data.chofer}>{data.chofer}</span>
                </div>
            </Row>
        </div >,
    });
}
export const obtenerInfoViewNormal = (data) => {
    let dataStyle = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
    return ({
        customTransform: data.ocultarBody ? 'translate(-50%, -230%)' : defaultTransform,
        header: <>
            <Col key={`marker_${data.markerId}`} className={`p-0 m-0`}>
                <h6 className="fw-bold pt-2 pb-0 mb-0" style={dataStyle} > {data.fecha}</h6>
            </Col>
        </>,
        body: data.ocultarBody ? null : <div className="m-0 p-0" key={`marker_${data.markerId}`}>
            <Col className="mt-0 pt-0">
                <Row className="my-0 py-0" xs={12}><h6 className="fw-bold" style={dataStyle} >{data.alerta} </h6></Row>
                <Row className="my-0 py-0" xs={12}><h6 className="fw-bold" style={dataStyle} > Vehículo: {data.titulo}</h6></Row>
                <Row className="my-0 py-0" xs={12}><h6 className="fw-bold" style={dataStyle} > Chofer: {data.chofer}</h6></Row>
            </Col>
        </div >,
    });
}
export const obtenerInfoViewTop = (data) => {
    let dataStyle = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
    return (<div className="pb-3">
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
            <div
                style={{
                    flex: '0 1 auto',
                    minWidth: 180,
                    ...dataStyle,
                }}
            >
                <span className="fw-bold">{data.fecha}</span>
            </div>
            <div
                className="ps-3"
                style={{
                    flex: '0 1 50% 100%',
                    minWidth: '50%',
                    ...dataStyle,
                }}
                title={data.alerta}
            >
                <span className="fw-bold" >
                    {data.alerta}
                </span>
            </div>
        </div>
        <Row className="flex-nowrap">
            <div style={{ width: "50%", ...dataStyle }} title={data.titulo}>
                <span className="fw-bold"> Vehículo: {data.titulo}</span>
            </div>
            <div style={{ width: "50%", ...dataStyle }} title={data.chofer}>
                <span className="fw-bold"> Chofer: {data.chofer}</span>
            </div>
        </Row>
        {/*data.alerta_omisiones ? <Row>
            <Col xs={12}><span className="fw-bold" title={data.alerta_omisiones}> {data.alerta_omisiones}</span></Col>
        </Row> : <></>*/}
    </div>);
}
// Asegúrate de tener ReactDOM y Google Maps cargados antes de esto.
const EmptyState = ({ icon, title, message, isLoading }) => (
    <Card.Body className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '40vh' }}>
        {isLoading ? (
            <>
                <Spinner animation="border" variant="primary" style={{ width: '4rem', height: '4rem', marginBottom: '1.5rem' }} />
                <h4 className="text-primary mb-3">Cargando mapa...</h4>
            </>
        ) : (
            <>
                <div className="mb-3 text-muted" style={{ fontSize: '4rem' }}>
                    {icon || <i className="far fa-calendar-alt"></i>}
                </div>
                <h4 className="mb-3">{title}</h4>
                <p className="text-muted mb-0 w-75">{message}</p>
            </>
        )}
    </Card.Body>
);

const TYPE_COLORS = [
    { colorStart: "#f1f1f1", colorEnd: "#f1f1f1" }, // alertas basicas
    { colorStart: "#57a639", colorEnd: "#57a639" }, // omisiones baja prioridad
    { colorStart: "#fbb040", colorEnd: "#fbb040" }, // omisiones mediana prioridad
    { colorStart: "#ed5565", colorEnd: "#ed5565" }, // omisiones alta prioridad
    { colorStart: "#8f00ff", colorEnd: "#8f00ff" }, // camaras ai
];


const createPieChart = (count, types) => {
    var size = 40;
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = size;
    const ctx = canvas.getContext("2d");

    if (!ctx) return canvas;


    const centerX = size / 2;
    const centerY = size / 2;

    // Círculo blanco detrás del número
    const radiusCirculoBorde = 20;
    ctx.beginPath();
    ctx.arc(centerX, centerY, radiusCirculoBorde, 0, 2 * Math.PI);
    ctx.fillStyle = "#dddddd";
    ctx.fill();

    var size = 38;
    let startAngle = 1.6;

    // Calcular el total de elementos sumando los largos de los arreglos
    const total = Object.values(types).reduce((sum, group) => sum + group.length, 0);

    // Dibujar cada slice proporcional
    Object.entries(types).forEach(([id, colorGroup]) => {
        const groupCount = colorGroup.length;
        const sliceAngle = (groupCount / total) * 2 * Math.PI;

        const color = colorGroup[0]; // usar el primero del grupo
        const endAngle = startAngle + sliceAngle;

        // Gradiente radial hacia el borde de la porción
        const angle = startAngle + sliceAngle / 2;
        const x = centerX + Math.cos(angle) * (size / 2);
        const y = centerY + Math.sin(angle) * (size / 2);

        const gradient = ctx.createLinearGradient(centerX, centerY, x, y);
        gradient.addColorStop(0, color.colorStart);
        gradient.addColorStop(1, color.colorEnd);

        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, size / 2, startAngle, endAngle);
        ctx.closePath();
        ctx.fillStyle = gradient;
        ctx.fill();

        startAngle = endAngle;
    });

    // Círculo blanco detrás del número
    const radiusCirculoBlanco = 14;
    ctx.beginPath();
    ctx.arc(centerX, centerY, radiusCirculoBlanco, 0, 2 * Math.PI);
    ctx.fillStyle = "white";
    ctx.fill();

    // Texto en el centro
    ctx.fillStyle = "#333";
    ctx.font = "600 14px Montserrat, sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(count.toString(), centerX, centerY);

    return canvas;
};

const GoogleMapSelector = ({
    className,
    mapStyle,
    initialCenter,
    myLocation,
    setMyLocation,
    markers,
    waypoints,
    addMarkerWhenTouchMap,
    showStreetView,
    zoomDefault = 13,
    geocercas,
    ...rest
}) => {
    const { isLoaded } = useGoogleMaps();
    const options = {
        mapId: 'quromap',
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true,
        gestureHandling: 'greedy',
    }

    const [infoViewTop, setInfoViewTop] = useState(null);
    const store = mapStore();
    const mapRef = useRef(null);
    const staticMarkers = useRef([]);
    const markersRef = useRef([]);
    const clusterRef = useRef(null);
    const polylinesClusterRef = useRef([]);
    const [zoomMap, setZoomMap] = useState(zoomDefault);
    const [firstLoad, setFirstLoad] = useState(true);
    const infoWindowRef = useRef(null);

    const onZoomChanged = () => {
        if (mapRef.current) {
            setZoomMap(mapRef.current.getZoom()); // Captura el nuevo zoom
        }
    };

    useEffect(() => {
        if (initialCenter?.zoomLevel) {
            setZoomMap(initialCenter.zoomLevel);
        }
    }, [initialCenter]);
    const [initListener, setInitListener] = useState(null);
    /* useEffect(() => {
         if (window.google && mapRef.current && initListener === null) {
             const map = mapRef.current;
             const panorama = map.getStreetView && map.getStreetView();
             if (panorama) {
                 const listener = google.maps.event.addListener(panorama, 'visible_changed', () => {
                     if (panorama.getVisible()) {
                         setTimeout(() => {
                             // Forzar un resize sobre el mapa principal también
                             google.maps.event.trigger(map, 'resize');
                             google.maps.event.trigger(panorama, 'resize');
                         }, 200);
                     }
                 });
                 setInitListener(listener);
                 return () => {
                     google.maps.event.removeListener(listener);
                 };
             }
         }
     }, [mapRef.current]);*/
    // const limpiarMarcadores = () => {
    //     if (markersRef.current && markersRef.current.length > 0) {
    //         console.log("🧹 Limpiando marcadores:", markersRef.current.length);

    //         markersRef.current.forEach((markerObj, index) => {
    //             try {
    //                 // ✅ CASO 1: Objeto con función destroy personalizada
    //                 if (markerObj && typeof markerObj.destroy === 'function') {
    //                     markerObj.destroy();
    //                     console.log(`✅ Marcador ${index} limpiado con destroy()`);
    //                 }
    //                 // ✅ CASO 2: Objeto con estructura {marker, circle}
    //                 else if (markerObj && typeof markerObj === 'object') {
    //                     if (markerObj.marker && typeof markerObj.marker.setMap === 'function') {
    //                         markerObj.marker.setMap(null);
    //                         console.log(`✅ Marcador ${index}.marker limpiado`);
    //                     }
    //                     if (markerObj.circle && typeof markerObj.circle.setMap === 'function') {
    //                         markerObj.circle.setMap(null);
    //                         console.log(`✅ Círculo ${index} limpiado`);
    //                     }
    //                 }
    //                 // ✅ CASO 3: Marcador directo (compatibilidad)
    //                 else if (markerObj && typeof markerObj.setMap === 'function') {
    //                     markerObj.setMap(null);
    //                     console.log(`✅ Marcador directo ${index} limpiado`);
    //                 }
    //                 // ❌ CASO 4: Objeto no reconocido
    //                 else {
    //                     console.warn(`⚠️ Marcador ${index} no tiene método setMap:`, markerObj);
    //                 }
    //             } catch (error) {
    //                 console.error(`❌ Error limpiando marcador ${index}:`, error, markerObj);
    //             }
    //         });

    //         markersRef.current = [];
    //         console.log("🧹 Todos los marcadores limpiados");
    //     }
    // };

    // Función para generar marcador con círculo opcional
    // Función para generar marcador con círculo opcional
    const generarMarcador = (AdvancedMarkerElement, ReactInfoOverlay, map, position, content) => {
        if (!map || !position || position.lat === undefined || position.lng === undefined) {
            return null;
        }

        try {
            // ✅ CREAR EL CONTENIDO DEL MARCADOR
            let markerContent = null;

            if (position.icon) {
                // ✅ CREAR ELEMENTO IMG DIRECTAMENTE (SIN ReactDOM.render)
                const markerImg = document.createElement("img");
                markerImg.src = position.icon.props?.src || position.icon.url;
                markerImg.style.width = "40px";
                markerImg.style.height = "40px";
                markerContent = markerImg;
            } else if (content) {
                const markerIco = document.createElement("img");
                markerIco.src = content.url;
                markerContent = markerIco;
            }

            // ✅ CREAR EL MARCADOR PRINCIPAL
            const marker = new AdvancedMarkerElement({
                position: { lat: position.lat, lng: position.lng },
                map: map,
                content: markerContent,
                title: position.title || 'Marcador'
            });

            // ✅ CREAR CÍRCULO SI TIENE RADIO
            let circle = null;
            if (position.radio && position.radio > 0) {
                // ✅ FUNCIÓN PARA OBTENER COLORES SEGÚN TIPO
                const obtenerEstiloCirculo = (position) => {
                    switch (position.tipo_real) {
                        case 99990: // Clientes
                            return {
                                strokeColor: '#28a745',  // Verde
                                fillColor: '#28a745',
                                strokeOpacity: 0.8,
                                fillOpacity: 0.15
                            };
                        case 99992: // Referencias
                            return {
                                strokeColor: '#ffc107',  // Amarillo
                                fillColor: '#ffc107',
                                strokeOpacity: 0.8,
                                fillOpacity: 0.15
                            };
                        default: // Por defecto
                            return {
                                strokeColor: '#4285F4',  // Azul
                                fillColor: '#4285F4',
                                strokeOpacity: 0.8,
                                fillOpacity: 0.15
                            };
                    }
                };

                const estiloCirculo = obtenerEstiloCirculo(position);

                circle = new google.maps.Circle({
                    ...estiloCirculo,
                    strokeWeight: 2,
                    map: map,
                    center: { lat: position.lat, lng: position.lng },
                    radius: position.radio
                });

                console.log(`🔵 Círculo creado para marcador en (${position.lat}, ${position.lng}) con radio: ${position.radio}m`);
            }

            // ✅ CREAR INFO WINDOW SI TIENE infoView
            if (position.infoViewTop) {
                // Event listener para mostrar info window
                google.maps.event.addListener(marker, "click", () => {
                    setInfoViewTop(position.infoViewTop);
                }
                );
            }
            if (position.infoView && ReactInfoOverlay) {
                // Event listener para mostrar info window
                google.maps.event.addListener(marker, "click", () => {
                    if (infoWindowRef.current) {
                        infoWindowRef.current.close();
                    }
                    const infoViewContainer = document.createElement("div");
                    ReactDOM.createRoot(infoViewContainer).render(
                        React.createElement(Card, { style: { minWidth: 100, backgroundColor: position?.infoView?.headerColor ?? 'white', transform: position?.infoView.customTransform ?? defaultTransform, } },
                            position.infoView.header
                                ? React.createElement(
                                    Row,
                                    {
                                        className:
                                            "py-2 ps-3 pe-2 m-0 d-flex flex-nowrap justify-content-between align-items-center border-all text-danger fw-bold",
                                    },
                                    position.infoView.header,
                                    React.createElement(
                                        'button',
                                        {
                                            style: {
                                                backgroundColor: 'lightgray',
                                                borderRadius: '50%',
                                                width: '1.2rem',
                                                height: '1.2rem',
                                                color: 'black',
                                                fontSize: '1.2rem',
                                                border: 'none',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: 0,
                                                opacity: .8,
                                                marginLeft: 10,
                                            },
                                            onClick: (event) => {
                                                event.stopPropagation();
                                                new_overlay.close();
                                            },
                                        },
                                        '×'
                                    )
                                )
                                : null,
                            !position.infoView.body ? <div className='m-0 p-0'></div> : <div className={"px-3"} style={{ backgroundColor: 'white', borderBottomLeftRadius: '5px', borderBottomRightRadius: '5px', }}>{position.infoView.body || null}</div>
                        )
                    );
                    const new_overlay = new ReactInfoOverlay(marker.position, infoViewContainer);
                    new_overlay.open(map);
                    infoWindowRef.current = new_overlay;
                });
            }

            // ✅ RETORNAR OBJETO COMPLETO
            return {
                marker: marker,
                circle: circle,
                infoWindow: null, // Se crea dinámicamente en el click
                destroy: () => {
                    if (marker) {
                        marker.setMap(null);
                    }
                    if (circle) {
                        circle.setMap(null);
                    }
                    if (infoWindowRef.current) {
                        infoWindowRef.current.close();
                    }
                }
            };

        } catch (error) {
            console.error("Error generando marcador:", error);
            return null;
        }
    };
    const [mapReady, setMapReady] = useState(false);

    const getRandomColor = () => {

        return '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
    };
    const [colorsMap, setColorsMap] = React.useState({});

    useEffect(() => {
        if (Array.isArray(geocercas)) {
            const newColors = {};
            geocercas.forEach(geo => {
                if (!colorsMap[geo.id_geocerca]) {
                    newColors[geo.id_geocerca] = getRandomColor();
                }
            });
            setColorsMap(prev => ({ ...prev, ...newColors }));
        }
    }, [geocercas]);

    useEffect(() => {
        if (!mapRef.current || !window.google) {
            setFirstLoad(false)
            return;
        };
        (async () => {
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

            class ReactInfoOverlay extends google.maps.OverlayView {
                constructor(position, content) {
                    super();
                    this.position = position;
                    this.container = content;
                }

                onAdd() {
                    const panes = this.getPanes();
                    panes.overlayMouseTarget.appendChild(this.container);
                }

                draw() {
                    const projection = this.getProjection();
                    const pos = projection.fromLatLngToDivPixel(new google.maps.LatLng(this.position));
                    if (pos) {
                        this.container.style.position = 'absolute';
                        this.container.style.left = pos.x + 'px';
                        this.container.style.top = pos.y + 'px';
                    }
                }

                onRemove() {
                    if (this.container.parentNode) {
                        this.container.parentNode.removeChild(this.container);
                    }
                }

                open(map) {
                    this.setMap(map);
                }

                close() {
                    this.setMap(null);
                }
            }
            // Limpiar marcadores anteriores
            //clusterRef.current?.setMap(null);
            staticMarkers.current.forEach((marker) => {
                try {
                    if (marker !== null) {
                        marker.setMap(null);
                    }
                } catch { }
            });
            staticMarkers.current = [];
            markersRef.current.forEach((marker) => {
                try {
                    if (marker !== null) {
                        marker.setMap(null);
                    }
                } catch { }
            });
            markersRef.current = [];
            polylinesClusterRef.current = [];

            // Agregar nuevos marcadores
            if (myLocation) {
                const marker = generarMarcador(AdvancedMarkerElement, ReactInfoOverlay, mapRef.current, myLocation, iconPin);
                if (marker !== null) {
                    staticMarkers.current.push(marker.marker);
                }
            }
            const markersArray = Array.isArray(markers) ? markers : [];
            // console.log("🧩 Lista de markers recibidos:", markersArray);

            (Array.isArray(markers) ? markers : []).forEach(position => {
                const hasCoords = position?.lat !== undefined && position?.lng !== undefined;
                const hasIcon = position?.icon?.props?.src || position?.icon?.url;

                // Solo agregar si tiene coordenadas válidas y un ícono válido
                if (hasCoords && hasIcon) {
                    // ✅ PASAR EL RADIO A LA FUNCIÓN generarMarcador
                    const markerObj = generarMarcador(AdvancedMarkerElement, ReactInfoOverlay, mapRef.current, position, null);

                    if (markerObj) {
                        // ✅ GUARDAR EL OBJETO COMPLETO (marcador + círculo)
                        markersRef.current.push(markerObj.marker);

                        // ✅ LOG PARA DEBUGGING
                        if (position.radio) {
                            console.log(`🎯 Marcador creado con radio: ${position.radio}m en (${position.lat}, ${position.lng})`);
                        }
                    }
                }
            });

            // const markersArray = Array.isArray(markers) ? markers : [];
            // //console.log("🧩 Lista de markers recibidos:", markersArray);
            // (Array.isArray(markers) ? markers : []).forEach(position => {
            //     const hasCoords = position?.lat !== undefined && position?.lng !== undefined;
            //     const hasIcon = position?.icon?.props?.src;

            //     // Solo agregar si tiene coordenadas válidas y un ícono válido
            //     if (hasCoords && hasIcon) {
            //         const marker = generarMarcador(AdvancedMarkerElement, ReactInfoOverlay, mapRef.current, position, null);
            //         if (marker) {
            //             markersRef.current.push(marker);
            //         }
            //     }
            //     //markersRef.current.push(generarMarcador(AdvancedMarkerElement, ReactInfoOverlay, mapRef.current, position, null));
            // });

            (Array.isArray(waypoints) ? waypoints : []).forEach((position, index) => {
                if (index === 0) {
                    staticMarkers.current.push(generarMarcador(AdvancedMarkerElement, ReactInfoOverlay, mapRef.current, { ...position, icon: obtenerIconoEvento(99993) }, iconPuntoF).marker);
                } else if (index === (waypoints.length - 1)) {
                    staticMarkers.current.push(generarMarcador(AdvancedMarkerElement, ReactInfoOverlay, mapRef.current, { ...position, icon: obtenerIconoEvento(99994) }, iconPuntoI).marker);
                } else {
                    if (position.showMarker) {
                        markersRef.current.push(generarMarcador(AdvancedMarkerElement, ReactInfoOverlay, mapRef.current, position, iconPunto).marker);
                    }
                }
            });




            // Crear MarkerClusterer
            /*
            const renderer = {
                render: ({ count, position, markers }) => {
                    const groupMarkers = markers.reduce((acc, m) => {
                        const prioridad = 0;
                        if (!acc[prioridad]) {
                            acc[prioridad] = [];
                        }
                        acc[prioridad].push(TYPE_COLORS[prioridad]);
                        return acc;
                    }, {});
                    const canvas = createPieChart(count, groupMarkers);

                    return new google.maps.marker.AdvancedMarkerElement({
                        position,
                        content: canvas,
                    });
                }
            };
            clusterRef.current = new MarkerClusterer({
                map: mapRef.current,
                markers: markersRef.current,
                renderer: renderer,
                onClusterClick: undefined,
            });*/
        })();
    }, [myLocation, markers, waypoints, mapRef, firstLoad, mapReady]);



    // useEffect(() => {
    //     return () => {
    //         // Cleanup al desmontar el componente
    //         limpiarMarcadores();
    //         if (infoWindowRef.current) {
    //             infoWindowRef.current.close();
    //             infoWindowRef.current = null;
    //         }
    //     };
    // }, []);

    if (!isLoaded) return (
        <EmptyState
            icon={<i className="fas fa-search"></i>}
            isLoading={true}
        />);

    return (<>
        {infoViewTop}
        <div className={`h-100 ${className}`} {...rest} style={{}}>
            <GoogleMap
                onLoad={(map) => {
                    store.setMap(map)
                    setMapReady(true); // invoca al useeffect markers
                    return mapRef.current = map
                }}
                zoom={zoomMap}
                options={options}
                center={initialCenter}
                yesIWantToUseGoogleMapApiInternals
                mapContainerStyle={{
                    width: "100%",
                    height: showStreetView ? "50%" : "100%",
                }}
                onZoomChanged={onZoomChanged}
                onClick={(event) => {
                    const lat = event.latLng.lat();
                    const lng = event.latLng.lng();
                    if (setMyLocation) {
                        setMyLocation({ lat: lat, lng: lng });
                    }
                }}
            >
                {waypoints && waypoints.length >= 2 &&
                    <>
                        {
                            //Trazado de rutas
                        }
                        <PolylineF
                            path={waypoints}
                            strokeColor="#FF0000"
                            strokeOpacity={1.0}
                            strokeWeight={3}
                            geodesic
                        />
                    </>
                }
                {
                    // Se añade Marcador SOLO si myLocation no esta vacio
                }
                {myLocation && myLocation.lat && myLocation.lng && (
                    <>
                        <CircleF
                            center={{ lat: myLocation.lat, lng: myLocation.lng }}
                            options={{
                                strokeColor: "#FF0000",
                                strokeOpacity: 0.2,
                                strokeWeight: 2,
                                fillColor: "#FF0000",
                                fillOpacity: 0.2,
                                radius: (myLocation.radius ?? 0.0),
                                clickable: false,
                                draggable: false,
                            }}
                        />
                    </>
                )}
                {
                    //Se añade Street View SOLO si showStreetView es true 
                }
                {/*showStreetView && initialCenter && initialCenter.lat && initialCenter.lng && (
                    <div style={{ width: "100%", height: "50%" }}>
                        <StreetViewPanorama
                            position={initialCenter}
                            options={{
                                pov: { heading: 100, pitch: 0 },
                                visible: true,
                            }}
                        />
                    </div>
                )*/}

                {/* //Geocercas */}
                {
                    Array.isArray(geocercas) && geocercas.map((geocerca, idx) => {
                        // Ordenar los puntos por "orden"
                        const puntosOrdenados = [...geocerca.puntos]
                            .filter(p => p.reg_status)
                            .sort((a, b) => a.orden - b.orden);

                        const path = puntosOrdenados.map(p => ({
                            lat: parseFloat(p.latitud),
                            lng: parseFloat(p.longitud),
                        }));
                        const color = colorsMap[geocerca.id_geocerca] || '#00FF00';

                        return (
                            <PolygonF
                                key={`geocerca-${idx}`}
                                path={path}
                                options={{
                                    fillColor: color,
                                    fillOpacity: 0.2,
                                    strokeColor: color,
                                    strokeOpacity: 0.6,
                                    strokeWeight: 2,
                                    clickable: false,
                                    draggable: false,
                                    editable: false,
                                    geodesic: true,
                                    zIndex: 1,
                                }}
                            />
                        );
                    })
                }

            </GoogleMap>
        </div>
    </>
    );
};

export default GoogleMapSelector;